import { createSearchParams, type Location, useLocation, useNavigate } from 'react-router';

import { RouteEnum } from '@/models/route/Route.model.ts';

export type PathParams = { params: Record<string, string>; pathname: Path } | Path;
type Path = RouteEnum | string;

interface Return {
  location: Location;
  push: (path: PathParams, state?: Record<string, unknown>) => void;
}

export const useAppNavigation = (): Return => {
  const navigate = useNavigate();
  const location = useLocation();

  return {
    location,
    push: (path, state) => {
      if (typeof path === 'object') {
        void navigate(
          {
            pathname: path.pathname,
            search: `?${createSearchParams(path.params)}`,
          },
          {
            state: {
              ...state,
              from: window.location.pathname + window.location.search,
            },
            viewTransition: true,
          },
        );
        return;
      }
      void navigate(path, {
        state: {
          ...state,
          from: window.location.pathname + window.location.search,
        },
        viewTransition: true,
      });
    },
  };
};
